export class OperationalLimitAction {

  public static getAcceptanceTerm: string = `[OperationalLimit] get_acceptance_term`;
  public static getAcceptanceTermError: string = `[OperationalLimit] get_acceptance_term_error`;
  public static getAcceptanceTermSuccess: string = `[OperationalLimit] get_acceptance_term_success`;


  public static acceptTerm: string = `[OperationalLimit] accept_term`;
  public static acceptTermError: string = `[OperationalLimit] accept_term_error`;
  public static acceptTermSuccess: string = `[OperationalLimit] accept_term_success`;

  public static rejectTerm: string = `[OperationalLimit] reject_term`;
  public static rejectTermError: string = `[OperationalLimit] reject_term_error`;
  public static rejectTermSuccess: string = `[OperationalLimit] reject_term_success`;

  constructor(
    public type: string,
    public payload?: any,
  ) {}

}
